import React from 'react';

const FILLED = '#F5A623';
const EMPTY = '#D7D7D2';

function Star({ size, filled, onClick, index }) {
  const isInteractive = typeof onClick === 'function';
  return (
    <span
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-label={isInteractive ? `${index + 1} étoile${index ? 's' : ''}` : undefined}
      onClick={isInteractive ? () => onClick(index + 1) : undefined}
      onKeyDown={isInteractive ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick(index + 1); } : undefined}
      style={{
        display: 'inline-flex',
        cursor: isInteractive ? 'pointer' : 'default',
        lineHeight: 0,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? FILLED : EMPTY}>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </span>
  );
}

export default function StarRating({ rating = 0, size = 14, onChange }) {
  const filled = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
  return (
    <span
      style={{ display: 'inline-flex', gap: 2, alignItems: 'center' }}
      role={onChange ? 'radiogroup' : 'img'}
      aria-label={`${filled}/5`}
    >
      {[0, 1, 2, 3, 4].map(i => (
        <Star key={i} index={i} size={size} filled={i < filled} onClick={onChange} />
      ))}
    </span>
  );
}
